module.exports = __webpack_public_path__ + "static/media/QR.511efe1d.jpg";